import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const GrphView = styled.div`
  ${p =>
    p.theme === 'theme1' &&
    `
    background: linear-gradient(180deg, #FFE98C, rgba(255, 255, 255, 0));
  `}
  ${p =>
    p.theme === 'theme2' &&
    `
    background: linear-gradient(180deg, #CDBDEC, rgba(255, 255, 255, 0));
  `}
`;
export const GrphViewHdr = styled.div`
  border-radius: 8px 8px 0 0;
  display: flex;
  flex-direction: column;
  padding: 40px 40px 0 40px;
  @media ${device.mobileS} {
    padding: 14px 10px 0 10px;
  }
  .font20 {
    font-size: 20px;
  }
  .latoBold {
    font-family: 'Lato', sans-serif;
    font-weight: 900 !important;
  }
  .latoBlack16 {
    font-family: Lato;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: rgb(0, 0, 0);
  }
`;
export const GrphViewDesc = styled.div`
  //padding: 0 40px;
  padding-left: 40px;
  margin: 14px 0 40px 0;
  display: flex;
  @media ${device.mobileS} {
    flex-wrap: wrap;
    padding: 0 10px;
  }
`;
export const GraphHeaderRow = styled.div`
  flex-direction: row;
  display: flex;
  width: 70%;
`;

export const GrphViewCol = styled.div`
  .amtLabel {
    font-weight: 900;
    color: #272d4d;
    display: flex;
    align-items: baseline;
    margin-bottom: 3px;
  }
  &:first-child {
    margin-right: 40px;
  }

  p:last-child:not(.highlighted) {
    //max-width: 112px;
  }

  .highlightText {
    background: #fcefb7;
    border-radius: 4px;
  }

  .highlighted {
    font-size: 11px;
    line-height: 12px;
    font-weight: 500;
    background: #fcefb7;
    border-radius: 4px;
  }
  .rowText {
    font-size: 11px;
    line-height: 12px;
    font-weight: 500;
    color: #272d4d;
  }
  .rowBoldText {
    font-size: 11px;
    line-height: 12px;
    font-weight: 500;
    //background: #fcefb7;
    // border-radius: 4px;
    // padding: 2px 4px;
    font-weight: 600;
  }
  @media ${device.mobileS} {
    &:nth-child(3) {
      margin-left: unset;
      margin-top: 20px;
    }
  }
`;
